export const booksOfAccountsFilterState = () => ({
  searchKey: '',
  status: 'all',
  route: 'all',
  user: null,
  page: 1,
  perPage: 10,
  accountId: null
});
